import { styled } from "../../styles";
import { ECG_COLORS } from "./ecgChart.constants";

// The chart area: a fixed label column + a horizontally scrollable grid. Sizes
// to its content (the surrounding container handles the bounded scrolling).
export const GridScrollArea = styled("div", {
  display: "flex",
  width: "100%",
  backgroundColor: ECG_COLORS.paper,
});

// The whole label column (all leads) is boxed, rounded on the left and flush
// with the grid on the right.
export const LeadLabelColumn = styled("div", {
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  backgroundColor: ECG_COLORS.paper,
  zIndex: 1,

  boxSizing: "border-box",
  border: "1px solid rgb(231, 154, 149)",
  borderRadius: "$2 0 0 $2",
});

export const LeadLabelCell = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "52px",
  fontFamily: "$openSans",
  fontWeight: 700,
  fontSize: "$text-lg",
  color: "$black",
  boxSizing: "border-box",

  // Separator between leads (matches the column border colour). The last lead
  // has none — its bottom line is the column's bottom border.
  borderBottom: "1px solid rgb(231, 154, 149)",
  "&:last-child": { borderBottom: "none" },
});

export const ScrollableTrace = styled("div", {
  flex: 1,
  overflowX: "auto",
  overflowY: "hidden",

  // Block removes the inline-element descender gap below the SVG, so the grid
  // sits flush against the scrollbar.
  "& svg": { display: "block" },

  // Slim scrollbar so the strip reads cleanly.
  "&::-webkit-scrollbar": { height: "10px" },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "$gray-60",
    borderRadius: "$pill",
  },
  "&::-webkit-scrollbar-track": { backgroundColor: "$gray-30" },
});
